import ninegrid from "../index.js";

class nxSidebar extends HTMLElement
{
	#minWidth;
	#maxWidth;
	
	constructor () {
		super();
		
		this.attachShadow({ mode: 'open' });
	};
	
	connectedCallback() {
		
		var round	= Number(this.getAttribute("round") || 8);
		var fill	= this.getAttribute("fill") || "#456BD9";
		var stroke	= this.getAttribute("stroke") || "#666";
		var strokeWidth	= Number(this.getAttribute("stroke-width") || 0);
		var size = round*2 + strokeWidth*2;
		var cx = round + strokeWidth;
		var cy = round + strokeWidth;
		
		this.#minWidth = Number(this.getAttribute("min-width") || 75);
		this.#maxWidth = Number(this.getAttribute("max-width") || 265);
		const headButtonColor = this.getAttribute("head-button-color") || "#eee";
		
		const template = document.createElement('template');
		
		/**
		 * 1. 첫번째	svg 클릭시 expand
		 * 2. collapse 시 첫번째 svg만 보임
		 * 3. expand 시 두번째 svg만 보임
		 * 4. 두번째 svg hover 시 3번째 svg 보임
		 * 5. 2,3번째 svg clieck시 collapse
		 */
		//this.shadowRoot.innerHTML = `
		template.innerHTML = `
			<style>
				@import "https://cdn.jsdelivr.net/npm/ninegrid2@${ninegrid.version}/dist/css/nxSidebar.css";
				${ninegrid.getCustomPath(this,"nxSidebar.css")}
				
				:host {
					--min-width: ${this.#minWidth}px;
					--max-width: ${this.#maxWidth}px;
					--head-button-color: ${headButtonColor};
				}
			</style>
			
			<div class="nx-head">
				<slot name="nx-head-content"></slot>

				<div class="nx-toggle-button-group">
					<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" class="nx-toggle-button" viewBox="0 0 16 16">
						<path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"/>
					</svg>
					<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" class="nx-toggle-button" viewBox="0 0 16 16">
						<path fill-rule="evenodd" d="M6 12.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-4-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5m4-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-4-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5"/>
					</svg>
					<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" class="nx-toggle-button" viewBox="0 0 16 16">
						<path fill-rule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"/>
					</svg>
				</div>
			</div>
			
			<div class="nx-body">
				<slot name="nx-body-content"></slot>
			</div>
			
			<div class="nx-foot">
				<slot name="nx-foot-content"></slot>
			</div>
			
			<div class="sidebar" data-background-color="dark">
				
				<div class="sidebar-wrapper scrollbar scrollbar-inner">
					<div class="sidebar-content">
						<ul class="nav nav-secondary">
							<li class="nav-item active">
								<a
									data-bs-toggle="collapse"
									href="#dashboard"
									class="collapsed"
									aria-expanded="false"
								>
									<i class="fas fa-home"></i><p>Dashboard</p><span class="caret"></span>
								</a>
								<div class="collapse" id="dashboard">
									<ul class="nav nav-collapse">
										<li><a href="https://cafe.naver.com/ninegrid" target="_new"><span class="sub-item">Q&A 게시판 (네이버카페)</span></a></li>
									</ul>
								</div>
							</li>
							<li class="nav-section">
								<span class="sidebar-mini-icon">
									<i class="fa fa-ellipsis-h"></i>
								</span>
								<h4 class="text-section">Components</h4>
							</li>
 							<li class="nav-item">
									<a data-bs-toggle="collapse" href="#base">
										<i class="fas fa-layer-group"></i><p>Base</p><span class="caret"></span>
									</a>
									<div class="collapse" id="base">
										<ul class="nav nav-collapse">
											<li><a onclick="javascript:sideMenu.goto(this, 'intro/intro.html')"><span class="sub-item">Introduction</span></a></li>
											<li><a onclick="javascript:sideMenu.goto(this, 'intro/start.html')"><span class="sub-item">Start</span></a></li>
											<li><a onclick="javascript:sideMenu.goto(this, 'intro/history.html')"><span class="sub-item">History</span></a></li>
										</ul>
									</div>
								</li>																	
								<li class="nav-item">
									<a data-bs-toggle="collapse" href="#sidebarLayouts">
										<i class="bi bi-layout-wtf"></i><p>Layouts</p><span class="caret"></span>
									</a>
									<div class="collapse" id="sidebarLayouts">
										<ul class="nav nav-collapse">
											<li><a onclick="javascript:sideMenu.goto(this, 'layout/info.html')"><span class="sub-item">Head Cell Legend</span></a></li>
											<li style="display:none;"><a onclick="javascript:sideMenu.goto(this, 'layout/lang.html')"><span class="sub-item">Internationalization</span></a></li>
											<li><a onclick="javascript:sideMenu.goto(this, 'layout/tree.html')"><span class="sub-item">Tree Grid</span></a></li>
											<li><a onclick="javascript:sideMenu.goto(this, 'layout/suppress.html')"><span class="sub-item">Suppress</span></a></li>
											<li><a onclick="javascript:sideMenu.goto(this, 'layout/paging.html')"><span class="sub-item">Paging</span></a></li>
											<li><a onclick="javascript:sideMenu.goto(this, 'layout/layout.html')"><span class="sub-item">Multi Table Layout</span></a></li>
											<li><a onclick="javascript:sideMenu.goto(this, 'layout/rowExpand.html')"><span class="sub-item">Row Expand</span></a></li>
											<li><a onclick="javascript:sideMenu.goto(this, 'layout/colExpand.html')"><span class="sub-item">Column Expand</span></a></li>
										</ul>
									</div>
								</li>
								<li class="nav-item">
									<a data-bs-toggle="collapse" href="#forms">
										<i class="bi bi-database-fill"></i><p>Data & View</p><span class="caret"></span>
									</a>
									<div class="collapse" id="forms">
										<ul class="nav nav-collapse">
											<li><a onclick="javascript:sideMenu.goto(this, 'data/manipulation.html')"><span class="sub-item">Data Manipulation</span></a></li>
											<li><a onclick="javascript:sideMenu.goto(this, 'view/selection.html')"><span class="sub-item">Cell Selection</span></a></li>
											<li><a onclick="javascript:sideMenu.goto(this, 'view/filtering.html')"><span class="sub-item">Fitering</span></a></li>
										</ul>
									</div>
								</li>
								<li class="nav-item">
									<a data-bs-toggle="collapse" href="#tables">
										<i class="bi bi-table"></i><p>Cell Components</p><span class="caret"></span>
									</a>
									<div class="collapse" id="tables">
										<ul class="nav nav-collapse">
											<li><a onclick="javascript:sideMenu.goto(this, 'components/rowIndicator.html')"><span class="sub-item">Row Indicator</span></a></li>
											<li><a onclick="javascript:sideMenu.goto(this, 'components/colIndicator.html')"><span class="sub-item">Column Indicator</span></a></li>
											<li><a onclick="javascript:sideMenu.goto(this, 'components/rowState.html')"><span class="sub-item">Row State</span></a></li>
										<li><a onclick="javascript:sideMenu.goto(this, 'components/rowPin.html')"><span class="sub-item">Row Pin</span></a></li>
										<li><a onclick="javascript:sideMenu.goto(this, 'components/rowDetail.html')"><span class="sub-item">Row Detail</span></a></li>
										<li><a onclick="javascript:sideMenu.goto(this, 'components/rowDrag.html')"><span class="sub-item">Row Drag</span></a></li>
											<li><a onclick="javascript:sideMenu.goto(this, 'components/renderer.html')"><span class="sub-item">Renderer</span></a></li>
											<li><a onclick="javascript:sideMenu.goto(this, 'components/inputText.html')"><span class="sub-item">Input</span></a></li>
											<li><a onclick="javascript:sideMenu.goto(this, 'components/textarea.html')"><span class="sub-item">Textarea</span></a></li>
											<li><a onclick="javascript:sideMenu.goto(this, 'components/inputColor.html')"><span class="sub-item">Input Color</span></a></li>
											<li><a onclick="javascript:sideMenu.goto(this, 'components/inputDate.html')"><span class="sub-item">Input Date</span></a></li>
											<li><a onclick="javascript:sideMenu.goto(this, 'components/checkBox.html')"><span class="sub-item">Check Box</span></a></li>
											<li><a onclick="javascript:sideMenu.goto(this, 'components/radio.html')"><span class="sub-item">Radio</span></a></li>
	\										<li><a onclick="javascript:sideMenu.goto(this, 'components/combo.html')"><span class="sub-item">Combo Box</span></a></li>
											<li><a onclick="javascript:sideMenu.goto(this, 'components/progress.html')"><span class="sub-item">Progress Bar</span></a></li>
											<li><a onclick="javascript:sideMenu.goto(this, 'components/button.html')"><span class="sub-item">Button</span></a></li>
											<li><a onclick="javascript:sideMenu.goto(this, 'components/img.html')"><span class="sub-item">Img</span></a></li>
											<li><a onclick="javascript:sideMenu.goto(this, 'components/svg.html')"><span class="sub-item">Svg</span></a></li>
											<li><a onclick="javascript:sideMenu.goto(this, 'components/chart.html')"><span class="sub-item">Chart</span></a></li>
											<li><a onclick="javascript:sideMenu.goto(this, 'components/expand.html')"><span class="sub-item">Expand Icon/Button/CheckBox</span></a></li>
										</ul>
									</div>
								</li>
							<li class="nav-item">
								<a data-bs-toggle="collapse" href="#webcomp">
									<i class="bi bi-table"></i><p>Web Components</p><span class="caret"></span>
								</a>
								<div class="collapse" id="webcomp">
									<ul class="nav nav-collapse">
										<li><a onclick="javascript:sideMenu.goto(this, 'web-components/i18n.html')"><span class="sub-item">i18n (Internationalization)</span></a></li>
									</ul>
								</div>
							</li>
							<li class="nav-item">
								<a data-bs-toggle="collapse" href="#events">
									<i class="bi bi-bell-fill"></i><p>Event</p><span class="caret"></span>
								</a>
								<div class="collapse" id="events">
									<ul class="nav nav-collapse">
										<li><a onclick="javascript:sideMenu.goto(this, 'event/event.html')"><span class="sub-item">Custom Event</span></a></li>
									</ul>
								</div>
							</li>
							<li class="nav-item">
								<a data-bs-toggle="collapse" href="#api">
									<i class="bi bi-share-fill"></i><p>API</p><span class="caret"></span>
								</a>
								<div class="collapse" id="api">
									<ul class="nav nav-collapse">
										<li><a onclick="javascript:sideMenu.goto(this, 'api/data.source.html')"><span class="sub-item">data.source</span></a></li>
										<li><a onclick="javascript:sideMenu.goto(this, 'api/data.add.html')"><span class="sub-item">data.add()</span></a></li>
										<li><a onclick="javascript:sideMenu.goto(this, 'api/data.insert.html')"><span class="sub-item">data.insert()</span></a></li>
										<li><a onclick="javascript:sideMenu.goto(this, 'api/data.delete.html')"><span class="sub-item">data.delete()</span></a></li>
										<li><a onclick="javascript:sideMenu.goto(this, 'api/data.setValue.html')"><span class="sub-item">data.setValue()</span></a></li>
										<li><a onclick="javascript:sideMenu.goto(this, 'api/data.clear.html')"><span class="sub-item">data.clear()</span></a></li>
										
										<li><a onclick="javascript:sideMenu.goto(this, 'api/data.get.html')"><span class="sub-item">data.get()</span></a></li>
										<li><a onclick="javascript:sideMenu.goto(this, 'api/data.getChangedData.html')"><span class="sub-item">data.getChangedData()</span></a></li>
										<li><a onclick="javascript:sideMenu.goto(this, 'api/data.isChanged.html')"><span class="sub-item">data.isChanged()</span></a></li>
										<li><a onclick="javascript:sideMenu.goto(this, 'api/data.findIndex.html')"><span class="sub-item">data.findIndex()</span></a></li>
										
										<li><a onclick="javascript:sideMenu.goto(this, 'api/scrollFirst.html')"><span class="sub-item">scrollFirst()</span></a></li>
										<li><a onclick="javascript:sideMenu.goto(this, 'api/scrollLast.html')"><span class="sub-item">scrollLast()</span></a></li>
										<li><a onclick="javascript:sideMenu.goto(this, 'api/scrollTo.html')"><span class="sub-item">scrollTo()</span></a></li>
										<li><a onclick="javascript:sideMenu.goto(this, 'api/selectCell.html')"><span class="sub-item">selectCell()</span></a></li>
										<li><a onclick="javascript:sideMenu.goto(this, 'api/selectRow.html')"><span class="sub-item">selectRow()</span></a></li>
										<li><a onclick="javascript:sideMenu.goto(this, 'api/selectCol.html')"><span class="sub-item">selectCol()</span></a></li>
										<li><a onclick="javascript:sideMenu.goto(this, 'api/selectArea.html')"><span class="sub-item">selectArea()</span></a></li>
										<li><a onclick="javascript:sideMenu.goto(this, 'api/selection.clear.html')"><span class="sub-item">selection.clear()</span></a></li>
										<li><a onclick="javascript:sideMenu.goto(this, 'api/selection.rows.html')"><span class="sub-item">selection.rows</span></a></li>
										<li><a onclick="javascript:sideMenu.goto(this, 'api/selection.subrows.html')"><span class="sub-item">selection.subrows</span></a></li>
										<li><a onclick="javascript:sideMenu.goto(this, 'api/selection.cols.html')"><span class="sub-item">selection.cols</span></a></li>
										<li><a onclick="javascript:sideMenu.goto(this, 'api/selection.binds.html')"><span class="sub-item">selection.binds</span></a></li>
										
										<li><a onclick="javascript:sideMenu.goto(this, 'api/ninegrid.confirm.html')"><span class="sub-item">ninegrid.confirm</span></a></li>
										<li><a onclick="javascript:sideMenu.goto(this, 'api/ninegrid.alert.html')"><span class="sub-item">ninegrid.alert</span></a></li>
									</ul>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
		`;
		
		this.shadowRoot.appendChild(template.content.cloneNode(true));
		template.remove();
		
		//this.shadowRoot.querySelector('.nx-toggle-button').addEventListener('click', () => { this.classList.nx-toggle('nx-collapse'); });
		//document.body.classList.add("body-on-sidebar-collapse");
		
		// 첫 번째 SVG 클릭 시 expand
		this.shadowRoot.querySelector('.nx-toggle-button:nth-of-type(1)').addEventListener('click', () => {
			this.#expand();
		});
		
		// 두 번째 및 세 번째 SVG 클릭 시 collapse 
		this.shadowRoot.querySelectorAll('.nx-toggle-button:nth-of-type(2), .nx-toggle-button:nth-of-type(3)').forEach(button => {
			button.addEventListener('click', e => {
				this.#collapse();
			});
		});

		this.addEventListener('mouseover', e => {
			const slot = this.shadowRoot.querySelector('slot[name="nx-body-content"]');
			const assignedNodes = slot.assignedNodes({ flatten: true });
						
			const sidebarItems = assignedNodes.filter(node => node.nodeName === 'UL')[0].querySelectorAll('nx-sidebar-item');

			sidebarItems.forEach(el => {
				el.classList.remove("nx-collapse");
				
				//const slot = el.shadowRoot.querySelector('slot[name="item-content"]');
				//slot.style.display = '';
				//slot.style.opacity = 1;
				//slot.classList.add("collapse");
				//slot.style.opacity = 0;
				//slot.style.height = '';
				//slot.style.padding = '';
				
				const slot = el.shadowRoot.querySelector('slot[name="item-content"]');
				const assignedNodes = slot.assignedNodes({ flatten: true });
				
				assignedNodes.forEach(node => {
					//if (node.nodeName === 'SPAN') {
						node.style.opacity = 1;
					//}
				});
			});
		});
		
		this.addEventListener('mouseout', () => {
			
			
			if (!this.classList.contains("nx-collapse")) return;
				
			
			const slot = this.shadowRoot.querySelector('slot[name="nx-body-content"]');
			const assignedNodes = slot.assignedNodes({ flatten: true });
			const sidebarItems = assignedNodes.filter(node => node.nodeName === 'UL')[0].querySelectorAll('nx-sidebar-item');

			sidebarItems.forEach(el => {
				el.classList.add("nx-collapse");
				
				//const slot = el.shadowRoot.querySelector('slot[name="item-content"]');
				//slot.style.display = 'none';
				
				//slot.style.transition = 'opacity 0.5s ease-out';
				//slot.style.opacity = 0;
				
				//slot.style.width = '0';
				//slot.style.padding = '0';
				
				const slot = el.shadowRoot.querySelector('slot[name="item-content"]');
				const assignedNodes = slot.assignedNodes({ flatten: true });
				
				assignedNodes.forEach(node => {
					//if (node.nodeName === 'SPAN') {
						node.style.transition = 'opacity 0.5s ease-out';
						node.style.opacity = 0;
					//}
				});
			});
			
			//const span = assignedNodes.filter(node => node.nodeName === 'SPAN')[0].querySelectorAll('nx-sidebar-item');

			

		});
		
		this.addEventListener('mouseover', e => {
			
			const slot = this.shadowRoot.querySelector('slot[name="nx-body-content"]');
			const assignedNodes = slot.assignedNodes({ flatten: true });
			const sidebarItems = assignedNodes.filter(node => node.nodeName === 'UL')[0].querySelectorAll('nx-sidebar-menuitem');

			sidebarItems.forEach(el => {
				el.classList.remove("collapse");
			});
		});
		
		this.addEventListener('mouseout', e => {
					
					
			if (!this.classList.contains("nx-collapse")) return;
			
			const slot = this.shadowRoot.querySelector('slot[name="nx-body-content"]');
			const assignedNodes = slot.assignedNodes({ flatten: true });
			const sidebarItems = assignedNodes.filter(node => node.nodeName === 'UL')[0].querySelectorAll('nx-sidebar-menuitem');

			sidebarItems.forEach(el => {
				el.classList.add("collapse");
			});
		});

		
		document.body.style.float = 'right';
		document.body.style.transition = 'width 0.5s ease-in-out';
		
		this.#collapse();
	};
	
	#expand = () => {
		this.classList.remove("nx-collapse");
		document.body.style.width = `calc(100% - ${this.#maxWidth}px)`;
		
		
	};
	
	#collapse = () => {
		this.classList.add("nx-collapse");
		document.body.style.width = `calc(100% - ${this.#minWidth}px)`;
		
		this.shadowRoot.host.style.width = 'var(--min-width)';
		setTimeout(() => {
			this.shadowRoot.host.style.width = '';
		}, 300);
	};
}

class nxSidebarItem extends HTMLElement {
	
	constructor() {
		super();
		this.attachShadow({ mode: 'open' });
	}

	connectedCallback() {
		this.render();
		
		this.classList.add("collapse");
	}

	render() {
		const iconClass = this.getAttribute('icon-class');
		
		this.shadowRoot.innerHTML = `
			<style>
				@import "https://cdn.jsdelivr.net/npm/ninegrid2@${ninegrid.version}/dist/css/nxSidebarItem.css";
				${ninegrid.getCustomPath(this,"nxSidebarItem.css")}
			</style>
			
			<li>
				<slot name="nx-icon"></slot>
				<slot name="item-content"></slot>
			</li>
		`;
	}
}

class nxSidebarMenuitem extends HTMLElement {
	
	#type;
	
	constructor() {
		super();
		this.attachShadow({ mode: 'open' });
	}

	connectedCallback() {
		this.#type		= this.getAttribute('type') || "item";
		
		this.render();
		
		this.classList.add("collapse");
		this.classList.add(this.#type);
		
		
		this.shadowRoot.querySelector(".menubar").addEventListener('click', (e) => {
			this.dispatchEvent(new CustomEvent('item-click', {
				detail: { message: 'Item clicked!' },
				bubbles: true,
				composed: true
			}));
		});
	}

	render() {
		
		const iconClass = this.getAttribute('icon-class');
		const contents	= this.innerHTML.trim();
		
		this.shadowRoot.innerHTML = `
		    <style>
		        @import "https://cdn.jsdelivr.net/npm/ninegrid2@${ninegrid.version}/dist/css/nxSidebarMenuitem.css";
		        ${ninegrid.getCustomPath(this,"nxSidebarMenuitem.css")}
		    </style>
			
		    <li>
		        <div class="icon ${iconClass}"></div>
		        <div class="menubar">
		            ${contents}
		        </div>
				<div class="expand-icon"></div>
		    </li>
		`;
	}
}

if (!customElements.get('nx-sidebar-menuitem')) {
	customElements.define('nx-sidebar-menuitem', nxSidebarMenuitem);
}

if (!customElements.get('nx-sidebar-item')) {
	customElements.define('nx-sidebar-item', nxSidebarItem);
}

if (!customElements.get('nx-sidebar')) {
	customElements.define("nx-sidebar", nxSidebar);
}

